// extracted by mini-css-extract-plugin
export default {"root":"MenuCategory_root__VLNX+","delete-icon":"MenuCategory_delete-icon__lDMWB","enabledisable":"MenuCategory_enabledisable__vdu0X"};